import { render, staticRenderFns } from "./navbarMenuItem.vue?vue&type=template&id=04083f9a&scoped=true&"
import script from "./navbarMenuItem.vue?vue&type=script&lang=js&"
export * from "./navbarMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./navbarMenuItem.vue?vue&type=style&index=0&id=04083f9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04083f9a",
  null
  
)

export default component.exports